import React, { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { HeroSection } from "./components/HeroSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { DemoSection } from "./components/DemoSection";
import { TestimonialsSection } from "./components/TestimonialsSection";
import { IntegrationsSection } from "./components/IntegrationsSection";
import { FAQSection } from "./components/FAQSection";
import { Footer } from "./components/Footer";

// Lazy load legal pages for better performance
const PrivacyPolicy = lazy(() => import("./components/PrivacyPolicy").then(module => ({ default: module.PrivacyPolicy })));
const TermsOfService = lazy(() => import("./components/TermsOfService").then(module => ({ default: module.TermsOfService })));
const CookiePolicy = lazy(() => import("./components/CookiePolicy").then(module => ({ default: module.CookiePolicy })));

// Scroll to top component
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }, [pathname]);

  return null;
};

const Home = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <DemoSection />
        <TestimonialsSection />
        <IntegrationsSection />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
};

// Loading component for lazy-loaded routes
const LoadingFallback = () => (
  <div className="min-h-screen bg-white flex items-center justify-center">
    <div className="text-center">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-slate-900 mx-auto mb-4"></div>
      <p className="text-slate-600">Loading...</p>
    </div>
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/cookies" element={<CookiePolicy />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;